<template>
  <v-card class="reports-wrapper">
    <v-card-text>
      <div class="rm-tabs-row">
        <v-tabs v-model="activeTab" background-color="transparent" class="rm-tabs">
          <v-tabs-slider class="rm-tab-slider"></v-tabs-slider>
          <v-tab v-for="(t, ti) in tabs" :key="'rt' + ti">{{ t.name }}</v-tab>
        </v-tabs>
      </div>

      <DocumentsView v-if="activeTab === 0" :levelling-framework="levellingFramework" />
      <LadderView v-if="activeTab === 1" :levelling-framework="levellingFramework" />
      <heatmap-view v-if="activeTab === 2" :levelling-framework="levellingFramework" />
    </v-card-text>
  </v-card>
</template>

<script>
import { ref } from 'vue';
import DocumentsView from '@/components/levelling/DocumentsView.vue';
import HeatmapView from '@/components/levelling/HeatmapView.vue';
import LadderView from '@/components/levelling/LadderView.vue';

export default {
  name: "LevellingReports",
  components: { DocumentsView, HeatmapView, LadderView },
  props: {
    levellingFramework: {
      type: Object,
      default: null,
    },
  },
  setup() {
    const activeTab = ref(0);
    const tabs = [
      { name: "Job Framework" },
      { name: "Career Ladder" },
      { name: "Heat Map" },
    ];

    return {
      activeTab,
      tabs,
    };
  },
};
</script>

<style lang="scss" scoped>
.reports-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  border-radius: 16px;
  padding: 0 1.5rem 1.5rem 1.5rem;
  margin:  0 1.5rem 1.5rem 1.5rem;
  width: 100%;
  overflow: scroll;
}

</style>
